import { INftYieldsResponse } from 'services/nft-yields.service';

// Yield values are per-share RMV income.
// Market mock: price='10000000000000000', decimal=18 → pricePerShare=0.01 RMV
// Target ~8% yield (GREAT): annualIncome = 0.01 * 0.08 = 0.0008 RMV/year
const DAILY = 0.0000021918; // 0.0008 / 365
const WEEKLY = 0.0000153846; // 0.0008 / 52
const MONTHLY = 0.0000666667; // 0.0008 / 12

export const NFT_YIELDS_MOCK: INftYieldsResponse = {
  most_yield_nfts: [
    {
      asset: { id: 81, token_id: '1000', name: 'Kinshasa', description: '', country_code: 'CD' },
      expectedAnnualYield: 0.08,
      annualYield: 0.08,
      dailyYield: DAILY,
      changeInDailyYield: 0,
      weeklyYield: WEEKLY,
      changeInWeeklyYield: 0,
      monthlyYield: MONTHLY,
      changeInMonthlyYield: 0,
      activeShares: 50000,
      totalShares: 50000,
      activeWallets: 120,
    },
  ],
};
